import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const state = {
  order: { id: null, order_items: [] },
  orderId:
    localStorage.getItem("wwp-orderId") &&
    localStorage.getItem("wwp-order-time") &&
    localStorage.getItem("wwp-order-time") > Date.now() - 60 * 60 * 1000
      ? localStorage.getItem("wwp-orderId")
      : null,
  pending: [],
  orders: [],
  states: [],
};

const getters = {
  getOrder: (state) => {
    return state.order;
  },
  getPending: (state) => {
    return state.pending;
  },
  getOrders: (state) => {
    return state.orders;
  },
  getStates: (state) => {
    return state.states;
  },
};

const actions = {
  async forPhotographer(context, data) {
    return await asyncHandler(
      HTTP({
        url: "order/for-photographer",
        method: "POST",
        data,
      })
    );
  },
  async search(context, data) {
    return await asyncHandler(
      HTTP({
        url: "order/search",
        method: "POST",
        data,
      })
    );
  },
  async calculate_tax({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({
        url: "order/calculate-tax",
        method: "POST",
        data,
      })
    );
    if (resp.success) {
      commit("set_order", resp.order);
    }
    return resp;
  },
  async get_states({ commit }) {
    const resp = await asyncHandler(
      HTTP({
        url: "utility/states",
        method: "GET",
      })
    );
    if (resp.success) {
      commit("set_states", resp.states);
    }
    return resp;
  },
  async get_orders({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({
        url: "order/get-orders",
        method: "POST",
        data,
      })
    );
    if (resp.success) {
      commit("set_orders", resp.orders);
    }
    return resp;
  },

  async zero_balance(context, data) {
    return await asyncHandler(
      HTTP({
        url: "order/zero-balance",
        method: "POST",
        data,
      })
    );
  },

  async apply_discount(context, data) {
    return await asyncHandler(
      HTTP({
        url: "/order/apply-discount",
        method: "POST",
        data,
      })
    );
  },
  async cancel(context, id) {
    return await asyncHandler(
      HTTP({
        url: "/order/cancel",
        method: "POST",
        data: { id },
      })
    );
  },

  async edit_email(context, data) {
    return await asyncHandler(
      HTTP({
        url: "/order/edit-email",
        method: "POST",
        data,
      })
    );
  },

  async add_note(context, data) {
    return await asyncHandler(
      HTTP({
        url: "/order/add-note",
        method: "POST",
        data,
      })
    );
  },

  async zip(context, id) {
    return await asyncHandler(
      HTTP({
        url: "/order/zip/" + id,
        method: "GET",
      })
    );
  },

  async zipStatus(context, id) {
    return await asyncHandler(
      HTTP({
        url: "/order/zip-status/" + id,
        method: "GET",
      })
    );
  },

  async release(context, id) {
    return await asyncHandler(
      HTTP({
        url: "/order/release",
        method: "POST",
        data: { id },
      })
    );
  },

  async resend(context, id) {
    return await asyncHandler(
      HTTP({
        url: "/order/resend",
        method: "POST",
        data: { id },
      })
    );
  },

  async get_pending({ commit }, outfitterId) {
    const resp = await asyncHandler(
      HTTP({
        url: "/order/get-pending",
        method: "POST",
        data: { outfitterId },
      })
    );
    if (resp.success) {
      commit("set_pending", resp.pending);
    }
    return resp;
  },

  async counter(context, data) {
    return await asyncHandler(
      HTTP({
        url: "order/counter",
        method: "POST",
        data,
      })
    );
  },

  async set_counter(context, data) {
    return await asyncHandler(
      HTTP({
        url: "order/set-counter",
        method: "POST",
        data,
      })
    );
  },

  async unset_counter(context, data) {
    return await asyncHandler(
      HTTP({
        url: "order/unset-counter",
        method: "POST",
        data,
      })
    );
  },

  async charge(context, data) {
    return await asyncHandler(
      HTTP({
        url: "order/charge",
        method: "POST",
        data,
      })
    );
  },

  async clear_order({ commit }) {
    commit("clear_order");
    return true;
  },

  async remove({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({
        url: "order/remove-item",
        method: "POST",
        data,
      })
    );
    if (resp.success) {
      commit("set_order", resp.order);
    }
    return resp;
  },

  async add({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({
        url: "order/add-item",
        method: "POST",
        data,
      })
    );
    if (resp.success) {
      commit("set_order", resp.order);
    }
    return resp;
  },
  async reload_order({ commit, state }) {
    let url = "order/" + state.orderId;
    const resp = await asyncHandler(
      HTTP({
        url,
        method: "POST",
        data: {},
      })
    );
    if (resp.success) {
      commit("set_order", resp.order);
    }
    return resp;
  },
  async load_order({ commit, state }, data) {
    let url = "order";
    if (state.orderId) {
      url += "/" + state.orderId;
    }
    const resp = await asyncHandler(
      HTTP({
        url,
        method: "POST",
        data,
      })
    );
    if (resp.success) {
      commit("set_order", resp.order);
    }
    return resp;
  },
  async load_order_hash({ commit }, hash) {
    const resp = await asyncHandler(
      HTTP({
        url: "order/hash/" + hash,
        method: "GET",
      })
    );
    if (resp.success) {
      commit("set_order_local", resp.order);
    }
    return resp;
  },
};

const mutations = {
  set_pending: (state, pending) => {
    state.pending = pending;
  },
  clear_order: (state) => {
    state.order = { id: null, order_items: [] };
    state.orderId = null;
    localStorage.removeItem("wwp-orderId");
    localStorage.removeItem("wwp-order-time");
  },
  set_order: (state, order) => {
    state.orderId = order.id;
    localStorage.setItem("wwp-orderId", order.id);
    localStorage.setItem("wwp-order-time", Date.now());
    state.order = order;
  },
  set_order_local: (state, order) => {
    state.orderId = order.id;
    state.order = order;
  },
  set_orders: (state, orders) => {
    state.orders = orders;
  },
  set_states: (state, states) => {
    state.states = states;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
